import { useQuery } from "@tanstack/react-query";
import { communityApi } from "@bw/shared/api";
import type { CommunityResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * The communities list (GET /communities), returned VERBATIM. A SINGLE fetch
 * backs both the hub's Discover and My Communities tabs — the page splits the
 * list client-side on the server's `is_member` flag (a pure view filter; the
 * server owns membership + counts). No client sort, no derived state.
 *
 * Cached under the `social.communities` key; a join / leave mutation invalidates
 * the `social` arm to refetch the list (see useCommunityMembership).
 */
export function useCommunities() {
  return useQuery<CommunityResponse[]>({
    queryKey: queryKeys.social.communities(),
    queryFn: () => communityApi.list(),
  });
}
